import React, { useState, useEffect, useContext } from 'react';
import GlobalCallNotification from './GlobalCallNotification';
import VideoCallRoom from './VideoCallRoom';
import SocketContext from '../../context/SocketContext';
import Swal from 'sweetalert2';

const GlobalCallNotificationWrapper = () => {
    // State for receiving a call
    const [activeCall, setActiveCall] = useState(null);
    // State for making a call
    const [outgoingCall, setOutgoingCall] = useState(null);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
        const handleInitiateCall = async (event) => {
            const { candidateId, candidateName } = event.detail;
            if (!candidateId) return;

            if (!socket || !socket.connected) {
                Swal.fire('Unable to Connect', 'Please wait for the connection to be ready and try again.', 'info');
                return;
            }

            const isOnline = await new Promise((resolve) => {
                let done = false;
                const timer = setTimeout(() => {
                    if (!done) resolve(false);
                }, 2500);
                socket.emit('check-online', { targetUserId: candidateId }, (res) => {
                    done = true;
                    clearTimeout(timer);
                    resolve(Boolean(res?.isOnline));
                });
            });

            if (!isOnline) {
                Swal.fire('Candidate Offline', 'The candidate is currently not online. Please try again later.', 'info');
                return;
            }

            setOutgoingCall({
                targetUserId: candidateId,
                targetName: candidateName
            });
        };
        window.addEventListener('initiate-video-call', handleInitiateCall);
        return () => window.removeEventListener('initiate-video-call', handleInitiateCall);
    }, [socket]);

    const handleAcceptCall = (callData) => {
        setActiveCall(callData);
    };

    const handleEndCall = () => {
        setActiveCall(null);
        setOutgoingCall(null);
    };

    return (
        <>
            {/* The ringing notification Banner */}
            {!activeCall && !outgoingCall && (
                <GlobalCallNotification 
                    onAccept={handleAcceptCall}
                />
            )}

            {/* The active Incoming Video Call interface Overlay */}
            {activeCall && !outgoingCall && (
                <VideoCallRoom 
                    callerMode={false}
                    targetUserId={activeCall.callerId}
                    onEndCall={handleEndCall}
                />
            )}

            {/* The active Outgoing Video Call interface Overlay */}
            {outgoingCall && !activeCall && (
                <VideoCallRoom 
                    callerMode={true}
                    targetUserId={outgoingCall.targetUserId}
                    onEndCall={handleEndCall}
                />
            )}
        </>
    );
};

export default GlobalCallNotificationWrapper;
